import { render, staticRenderFns } from "./InfoSideCard.vue?vue&type=template&id=015df8ca&"
import script from "./InfoSideCard.vue?vue&type=script&lang=js&"
export * from "./InfoSideCard.vue?vue&type=script&lang=js&"
import style0 from "./InfoSideCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports